import React, { FC, useCallback, useMemo, useState } from 'react';

import { EvChips, FLEX_WRAP, TITLE_MODES } from '@evinced-private/ui-common';

import { PlatformPopup } from 'src/common/components/platform-popup/PlatformPopup';

import { LABELS_CHIPS_LABELS } from './LabelsChips.labels';
import { LabelsChipsProps } from './LabelsChips.types';

import './LabelsChips.scss';

const MAX_VISIBLE_CHIPS = 5;

export const LabelsChips: FC<LabelsChipsProps> = ({ labels, popupTitle, dataAutomationId }) => {
	const [isPopupOpen, setIsPopupOpen] = useState(false);

	const openPopup = useCallback(() => setIsPopupOpen(true), []);
	const closePopup = useCallback(() => setIsPopupOpen(false), []);

	const chips = useMemo(
		() =>
			labels.map((item) =>
				typeof item === 'string' ? { id: item, label: item } : { id: item.label, ...item }
			),
		[labels]
	);
	const showMoreProps = useMemo(() => ({ onClick: openPopup }), [openPopup]);
	const buttons = useMemo(
		() => [
			{
				onClick: closePopup,
				title: LABELS_CHIPS_LABELS.CLOSE_BUTTON,
				type: 'primary' as const,
				wrapperClassName: 'cancel-button'
			}
		],
		[closePopup]
	);

	const hasOverflow = useMemo(() => labels.length > MAX_VISIBLE_CHIPS, [labels]);

	return (
		<>
			<EvChips
				chips={chips}
				wrap={FLEX_WRAP.WRAP}
				maxVisible={MAX_VISIBLE_CHIPS}
				showMoreProps={hasOverflow ? showMoreProps : undefined}
				dataAutomationId={dataAutomationId}
			/>
			{hasOverflow && (
				<PlatformPopup
					title={popupTitle ?? LABELS_CHIPS_LABELS.POPUP_TITLE}
					titleMode={TITLE_MODES.NORMAL}
					isControlled
					isOpen={isPopupOpen}
					onClose={closePopup}
					buttons={buttons}
				>
					<div className="labels-chips__popup-body">
						<EvChips chips={chips} wrap={FLEX_WRAP.WRAP} />
					</div>
				</PlatformPopup>
			)}
		</>
	);
};
